import { render, staticRenderFns } from "./Netscallback.vue?vue&type=template&id=cf2f5292&scoped=true"
import script from "./Netscallback.vue?vue&type=script&lang=js"
export * from "./Netscallback.vue?vue&type=script&lang=js"
import style0 from "./Netscallback.vue?vue&type=style&index=0&id=cf2f5292&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2f5292",
  null
  
)

export default component.exports